import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-449f068e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "darkblue" }
const _hoisted_2 = { class: "template" }
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = { class: "my-name-is" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p class=\"description\" data-v-449f068e> I&#39;m a <span class=\"green\" data-v-449f068e>full stack software engineer</span>, a generalist at heart, with over <span class=\"green\" data-v-449f068e>6+ years of experience</span> building mobile apps, web apps, APIs, and microservices with the proven ability to lead small to mid size <span class=\"green\" data-v-449f068e>global</span> engineering teams in order to <span class=\"green\" data-v-449f068e>design, implement and deliver a product</span>. </p>", 1)

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeUpRight } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPage',
  setup(__props) {

const { t } = useLanguageSwitcher();


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { "data-aos": _unref(FadeUpRight) }, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)('landingPage.myNameIs')), 1),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(t)('landingPage.name')), 1),
        _hoisted_6,
        _createVNode(_component_v_btn, {
          class: "button",
          href: "#achievements",
          variant: "outlined"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Check out my work")
          ]),
          _: 1
        })
      ], 8, _hoisted_3)
    ])
  ]))
}
}

})